import React, { useEffect, useRef, useState } from 'react';
import {
  BarChartOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  GlobalOutlined,
  LinkOutlined,
  TeamOutlined,
} from '@ant-design/icons';

const metrics = [
  { value: 138, label: 'Academic Research & Development', icon: ExperimentOutlined },
  { value: 236, label: 'Data & Inventory Management', icon: DatabaseOutlined },
  { value: 301, label: 'Models & Maps Development', icon: GlobalOutlined },
  { value: 1930, label: 'Capacity Building', icon: TeamOutlined, compact: true },
  { value: 285, label: 'Linkages & Commercialization', icon: LinkOutlined },
  { value: 522, label: 'Research Impact', icon: BarChartOutlined },
];

const formatValue = (value, compact) => {
  if (compact) return `${(value / 1000).toFixed(2)}K+`;
  return new Intl.NumberFormat('en-US').format(value);
};

const ImpactMetric = ({ value, label, icon: Icon, compact, active }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!active) return undefined;

    const duration = 1400;
    const start = performance.now();
    let frame;

    const update = (time) => {
      const progress = Math.min((time - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCurrent(Math.round(value * eased));
      if (progress < 1) frame = requestAnimationFrame(update);
    };

    frame = requestAnimationFrame(update);
    return () => cancelAnimationFrame(frame);
  }, [active, value]);

  return (
    <article className="impact-card impact-card-premium">
      <span className="impact-card-icon impact-card-icon-premium" aria-hidden="true"><Icon /></span>
      <strong className="impact-number impact-number-premium">{formatValue(current, compact)}</strong>
      <span className="impact-card-title impact-card-title-premium">{label}</span>
    </article>
  );
};

const Impact = () => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setActive(true);
        observer.disconnect();
      }
    }, { threshold: 0.2 });

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="impact-section impact-section-premium"
      aria-labelledby="rsgcrl-impact-title"
    >
      <div className="impact-overlay impact-overlay-premium">
        <div className="impact-inner impact-inner-premium">
          <header className="impact-heading impact-heading-premium">
            <span className="impact-eyebrow">RSGCRL by the numbers</span>
            <h2 id="rsgcrl-impact-title">Impact</h2>
          </header>
          <div className="impact-grid impact-grid-premium">
            {metrics.map((metric) => (
              <ImpactMetric key={metric.label} {...metric} active={active} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
